import { CATALOG_APPROVAL_API } from "./catalogApprovalMessages";

const types = { families: "family", subfamilies: "subfamily", categories: "category", subcategories: "subcategory", "suppliers/options": "supplier" };
export const pendingReferenceLabel = language => language === "es" ? "Pendiente de aprobación" : language === "ca" ? "Pendent d'aprovació" : "Pending approval";
export const pendingReferenceRow = (request, language) => ({ ...request.payload, id: -Number(request.id),
  name: `${request.payload?.name || request.payload?.code || ""} · ${pendingReferenceLabel(language)}`,
  approval_pending: true, approval_request_id: Number(request.id) });

// A client scoped to one option-loading batch; purchasing and stock selectors
// keep using their ordinary client and never receive these draft references.
export function catalogReferenceClient(client, language) {
  let pending;
  return { get: async (url, config) => {
    const match = url.match(/^\/api\/purchasing\/(families|subfamilies|categories|subcategories|suppliers\/options)(?:\?|$)/);
    if (!match) return client.get(url, config);
    const query = new URLSearchParams(url.split("?")[1] || "");
    const businessUnitId = config?.params?.business_unit_id || query.get("business_unit_id");
    pending ||= client.get(`${CATALOG_APPROVAL_API}/references`, { ...config,
      params: { ...(businessUnitId ? { business_unit_id: businessUnitId } : {}) } });
    const type = types[match[1]];
    const parentCategoryId = config?.params?.category_id || query.get("category_id");
    // A draft category can only have draft children until it is published.
    const published = type === "subcategory" && Number(parentCategoryId) < 0 ? { data: [] } : client.get(url, config);
    const [response, references] = await Promise.all([published, pending]);
    const drafts = (references.data?.references?.[type] || []).filter(row => !parentCategoryId || type !== "subcategory" || String(row.category_id) === String(parentCategoryId))
      .map(row => ({ ...row, name: `${row.name || ""} · ${pendingReferenceLabel(language)}` }));
    return { ...response, data: [...(response.data || []), ...drafts] };
  } };
}
